var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 88,
    viewBox: "0 0 76 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.5808 3.66817C75.5808 1.65427 73.9266 0 71.9127 0H14.5347C6.65891 0 0.419434 6.23948 0.419434 13.9354C0.419434 13.9354 0.419434 76.7797 0.419434 76.8157C0.419434 83.0552 5.54408 88 11.7836 88H71.7329C73.2073 88 74.6638 87.083 75.2212 85.6085C75.7786 84.134 75.401 82.4978 74.1244 81.5807C70.8698 79.5129 70.672 74.9816 73.567 72.9677C74.1783 72.3564 75.5629 71.0977 75.455 69.2995C75.5449 69.0118 75.5808 3.66817 75.5808 3.66817ZM7.75576 76.8157C7.75576 74.622 9.58985 72.9677 11.7836 72.9677H64.5943C62.976 75.6649 63.3177 78.8296 64.5943 80.6637H11.7836C9.58985 80.6637 7.75576 79.0274 7.75576 76.8157ZM68.2625 65.6314H11.8015C10.381 65.6314 9.03243 65.9011 7.77374 66.3866V13.9354C7.77374 10.2673 10.8845 7.33633 14.5527 7.33633H68.2805V65.6314H68.2625Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.d56a92f43c57f7873f1855691dec5e54.svg";
export { ForwardRef as ReactComponent };